import {combineReducers} from 'redux';

import {realestate} from './realestate';
import {premises} from './premises';
import {residence} from './residence';
import {
	areaFilters,
	rentFilters,
	searchFilters,
} from './filters';
import {viewstate} from './viewstate';
import {emptyobjectstate} from './emptyobjectstate';
import {globalSearchResults} from './globalSearchResults';

// ES6 allows to pass in just the property if the key and value are the same.
const rootReducer = combineReducers({
	realestate,
	premises,
	residence,
	areaFilters,
	rentFilters,
	searchFilters,
	viewstate,
	emptyobjectstate,
	globalSearchResults,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/js/reducers/index.js